import { VALIDATION_STATES } from '../../../core/const/fields.js';

export default {
  props: {
    fieldId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    validationState: {
      type: String,
      default: VALIDATION_STATES.unprocessed,
    },
    errorMessage: {
      type: String,
      required: false,
    },
    onChange: {
      type: Function,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalValue: !!this.value,
    };
  },
  computed: {
    hasSlot() {
      return !!this.$slots.default;
    },
    isValid() {
      return this.validationState === VALIDATION_STATES.valid;
    },
    hasError() {
      return this.validationState === VALIDATION_STATES.error;
    },
    labelMessage() {
      return this.hasError ? this.errorMessage : this.label;
    },
  },
  update() {
    this.internalValue = !!this.value;
  },
};
